import { ButtonNew, ColorOptions, Image, ModalDialogNew, Spacer, Text } from '@jfs/ui-new'
import Lottie from 'react-lottie'
import * as ActivatingQR from '../../assets/lottie/activatingQR.json'
import * as SuccessTick from '../../assets/lottie/successTick.json'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'

interface props {
  status: string
  onClose: () => void
}

const BottomSheet = ({ status, onClose }: props) => {
  const activatingQR = {
    loop: true,
    autoplay: true,
    animationData: ActivatingQR,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid meet',
    },
  }

  const successTick = {
    loop: true,
    autoplay: true,
    animationData: SuccessTick,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid meet',
    },
  }

  return (
    <ModalDialogNew isFullWidth show={status.length > 0} backgroundColor={'TRANSPARENT45'} type={'bottom'}>
      <ModBox
        alignItems={'center'}
        justifyContent={'center'}
        borderTopLeftRadius={16}
        borderTopRightRadius={16}
        h={300}
        w={'100%'}
        zIndex={1000000}
        backgroundColor={'WHITE'}
        paddingTop={32}>
        <ModBox show={status === 'failed' || status === 'permissiondenied'} height={70} width={70}>
          <Image source={require('../../assets/images/qr_invalid.png')} width={70} height={70} />
        </ModBox>
        <ModBox show={status !== 'failed' && status !== 'permissiondenied'} height={70} width={70}>
          <Lottie options={status === 'activating' ? activatingQR : successTick} height={70} width={70} />
        </ModBox>
        <Spacer direction="vertical" size={16} />
        <ModBox show={status !== 'failed' && status !== 'permissiondenied'}>
          <Text
            fontFamily="jiotype-bold"
            fontSize={16}
            color={'BLACK_21'}
            title={status === 'activating' ? 'Activating QR..' : 'QR Activated'}
          />
        </ModBox>
        <Spacer direction="vertical" size={8} />
        <ModBox
          show={status === 'failed' || status === 'permissiondenied' || status === 'activating'}
          paddingHorizontal={32}>
          <Text
            textAlign="center"
            fontFamily="jiotype-medium"
            fontSize={14}
            color={'BLACK_75'}
            title={
              status === 'activating'
                ? 'UPI linking is in process. Please wait.'
                : status === 'failed'
                  ? 'The details scanned from the QR code is not in the correct format.'
                  : status === 'permissiondenied'
                    ? 'Provide Camera Access to scan'
                    : ''
            }
          />
        </ModBox>
        <ModBox show={status === 'failed'} marginTop={8}>
          <Text
            fontFamily="jiotype-medium"
            fontSize={12}
            color={'BLACK_75'}
            title={'Scan again or try scanning a different QR.'}
          />
        </ModBox>
        <ModBox
          alignItems={'center'}
          w={'100%'}
          marginTop={24}
          marginBottom={40}
          show={status === 'failed' || status === 'permissiondenied'}>
          <ButtonNew
            width={280}
            color={'#0070B6' as ColorOptions}
            titleColor={'WHITE'}
            title={'Retry'}
            height={48}
            testID="sheet-close"
            onPress={onClose}
          />
        </ModBox>
      </ModBox>
    </ModalDialogNew>
  )
}

export { BottomSheet }
